import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthPage() {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, login } = useAuth();
  const navigate = useNavigate();

  const errMap = {
    'auth/email-already-in-use': 'Dit e-mailadres is al in gebruik.',
    'auth/invalid-email': 'Ongeldig e-mailadres.',
    'auth/weak-password': 'Wachtwoord moet minstens 6 tekens bevatten.',
    'auth/user-not-found': 'Geen account gevonden met dit e-mailadres.',
    'auth/wrong-password': 'Onjuist wachtwoord.',
    'auth/invalid-credential': 'Onjuiste inloggegevens.'
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (mode === 'register' && password !== confirm) {
      return setError('Wachtwoorden komen niet overeen.');
    }
    setLoading(true);
    try {
      if (mode === 'register') {
        await register(email, password);
      } else {
        await login(email, password);
      }
      navigate('/dashboard');
    } catch (err) {
      setError(errMap[err.code] || 'Er ging iets mis. Probeer opnieuw.');
    }
    setLoading(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">🏕 Kamp Systeem</div>
        <p className="auth-tagline">Vrijwilligersbeheer voor kamp organisaties</p>

        <div className="tabs" style={{ marginBottom: 28 }}>
          <button className={`tab ${mode === 'login' ? 'active' : ''}`} onClick={() => { setMode('login'); setError(''); }}>
            Inloggen
          </button>
          <button className={`tab ${mode === 'register' ? 'active' : ''}`} onClick={() => { setMode('register'); setError(''); }}>
            Registreren
          </button>
        </div>

        {error && (
          <div className="alert alert-error" style={{ marginBottom: 20 }}>
            <span>⚠</span> {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>E-mailadres <span className="req">*</span></label>
            <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="naam@email.be" required autoComplete="email" />
          </div>

          <div className="field">
            <label>Wachtwoord <span className="req">*</span></label>
            <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Minimaal 6 tekens" required autoComplete={mode === 'register' ? 'new-password' : 'current-password'} />
          </div>

          {mode === 'register' && (
            <div className="field">
              <label>Bevestig wachtwoord <span className="req">*</span></label>
              <input className="input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                placeholder="Herhaal wachtwoord" required autoComplete="new-password" />
            </div>
          )}

          <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading}>
            {loading ? 'Even geduld...' : mode === 'login' ? 'Inloggen' : 'Account aanmaken'}
          </button>
        </form>

        {mode === 'login' && (
          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-3)' }}>
            Geen account?{' '}
            <button style={{ background: 'none', border: 'none', color: 'var(--primary)', cursor: 'pointer', fontWeight: 500, fontSize: 13 }}
              onClick={() => setMode('register')}>Registreer je hier</button>
          </p>
        )}
      </div>
    </div>
  );
}
